import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Image = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 2H3C2.44772 2 2 2.44772 2 3V9.40403L3.75756 7.64647C3.93351 7.47052 4.21206 7.45073 4.41112 7.60002L7.20589 9.69611L11.5688 6.06036C11.7562 5.90416 12.029 5.90606 12.2143 6.06484L14 7.59544V3C14 2.44772 13.5523 2 13 2ZM14 8.91252L13.8968 8.8241L11.8843 7.09911L7.54231 10.7175C7.36428 10.8658 7.10762 10.8724 6.92222 10.7334L4.15803 8.66021L2 10.8182V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V8.91252ZM3 1C1.89543 1 1 1.89543 1 3V13C1 14.1045 1.89543 15 3 15H13C14.1045 15 15 14.1045 15 13V3C15 1.89543 14.1045 1 13 1H3ZM7 6C7.41421 6 7.75 5.66421 7.75 5.25C7.75 4.83579 7.41421 4.5 7 4.5C6.58579 4.5 6.25 4.83579 6.25 5.25C6.25 5.66421 6.58579 6 7 6ZM7 7C7.9665 7 8.75 6.2165 8.75 5.25C8.75 4.2835 7.9665 3.5 7 3.5C6.0335 3.5 5.25 4.2835 5.25 5.25C5.25 6.2165 6.0335 7 7 7Z"
        fill={color}
      />
    </svg>
  )
})

export default Image
